import { base } from "../base";
import { base_v2 } from "../base_v2";

async function billDebt(type, data) {
  return base.get(`accountants/debt/${type}/unpaid-orders`, data);
}
async function billDebtV2(type, data) {
  return base_v2.get(`accountants/debt/${type}/unpaid-orders`, data);
}

async function billPaid(type, data) {
  return base.get(`accountants/debt/${type}/remittance-advice`, data);
}

async function addRemittanceAdvice(data) {
  return base.post('services/remittance-advice', data);
}

async function getRemittanceAdvice(data) {
  return base.get('services/remittance-advice', data);
}

async function getDebtDetailPO(data) {
  return base.get('accountants/dashboard/debt/details-po', data);
}

async function cancelRemittanceAdvice(data) {
  return base.put('services/remittance-advice', data);
}

export const accountantService = {
  billDebt,
  billPaid,
  addRemittanceAdvice,
  getRemittanceAdvice,
  getDebtDetailPO,
  cancelRemittanceAdvice,
  billDebtV2
};
